// @flow
import React, { Component } from "react";
import { Icon, Tag, Popconfirm } from "antd";

type Props = {
  id: string,
  itemId: string,
  name: string,
  tagClicked: Function,
  removeTag: Function,
  editMode: boolean
};
type State = {
  isActive: boolean
};

class ItemTag extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      isActive: true
    };
  }

  tag: Tag;

  _onClick = (e: Event) => {
    const { id, tagClicked, editMode } = this.props;
    if (!editMode) tagClicked(id);
  };

  _onClose = (e: Event) => {
    const { id, removeTag, itemId } = this.props;
    this.tag.close(e);
    this.setState({ isActive: false });
    removeTag(id, itemId);
    console.log("removeTag id ", id);
  };

  render() {
    const { name, editMode } = this.props;
    return editMode ? (
      <Popconfirm
        placement="topLeft"
        title="Are you sure delete this tag?"
        onConfirm={this._onClose}
        okText="Yes"
        cancelText="No"
      >
        <Tag className="item-tag" color="#999" ref={node => (this.tag = node)}>
          {name}
        </Tag>
        {this.state.isActive && <Icon className="" type="close-circle" />}
      </Popconfirm>
    ) : (
      <Tag
        className="item-tag"
        color="#999"
        onClick={this._onClick}
        ref={node => (this.tag = node)}
      >
        {name}
      </Tag>
    );
  }
}

export default ItemTag;



// WEBPACK FOOTER //
// ./src/components/itemtag/index.js